import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from './FirebaseConfig';
import { signInWithEmailAndPassword } from 'firebase/auth';
import '../../css/Login.css';
import '../../css/Fondo.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/secciones');
    } catch (error) {
      console.error('Error logging in:', error.message);
      setError("Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="divfill fondo-3">
      <div className="login-container">
        <form className="login-form" onSubmit={handleLogin}>
          <div className="input-container">
            <h2 className="login-title">Iniciar Sesión</h2>
            <label className="input-label">E-mail:</label>
            <input
              className="input-field"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="input-container">
            <label className="input-label">Contraseña:</label>
            <input
              className="input-field"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <button
            className="login-button"
            type="submit"
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? (
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            ) : (
              'Iniciar Sesión'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
